import * as React from "react";
import type { SVGProps } from "react";
const SvgIconArrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.34 4.04q-.3.13-.45.4c-.1.18-.1.23-.1 2.48 0 1.23.01 2.3.03 2.46.08.99.32 1.84.76 2.7.99 1.96 2.82 3.36 4.96 3.8.66.15.13.14 7.22.14 3.57 0 6.5.02 6.5.03l-1.3 1.32c-1.03 1.03-1.33 1.34-1.37 1.43-.08.18-.1.48-.02.67.07.18.24.37.42.46.13.07.16.07.37.07.4 0 .21.17 2.59-2.2 2.39-2.39 2.25-2.22 2.25-2.62s.15-.22-2.22-2.58c-1.31-1.32-2.12-2.1-2.19-2.14-.16-.1-.39-.13-.58-.1l-.24.08c-.12.07-.3.24-.37.39-.06.11-.07.15-.07.37 0 .4-.07.32 1.44 1.83l1.3 1.3h-6.4c-6-.02-6.4-.02-6.65-.06q-1.58-.27-2.7-1.21-1.57-1.3-1.95-3.37c-.03-.2-.04-.52-.05-2.62l-.01-2.4-.06-.14c-.07-.18-.26-.38-.43-.47-.2-.1-.49-.1-.68-.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconArrowDownRight;
